import type { ComponentProps } from 'react';
import { OwcTableCell } from '@one/react';

export type PocTableCellProps = ComponentProps<typeof OwcTableCell>;

export const PocTableCell: React.FC<PocTableCellProps> = (props) => <OwcTableCell {...props} />;
